'use client';
import { getVideoEmbedUrl } from '@/lib/utils/video-url';
import styles from './externalVideo.module.scss';

type Props = {
  sourceType?: string | null;
  source?: string | null;
  borderRadius?: number | null;
};

export default function ExternalVideo(props: Props) {
  const sourceType = props?.sourceType || null;
  const source = props?.source || null;
  const borderRadius = props?.borderRadius;

  let embedUrl: string | null = null;

  if (sourceType === 'directurl') {
    embedUrl = source;
  } else if (source) {
    embedUrl = getVideoEmbedUrl(source);
  }

  if (!embedUrl) {
    return (
      <div style={{ padding: '1rem', border: '1px dashed red' }}>
        Unsupported video URL format:
        <br />
        <code>{source}</code>
      </div>
    );
  }

  const iframeClassNames = `${styles.video}`;

  function videoElement(embedUrl: string) {
    if (source !== 'directurl') {
      return (
        <iframe
          className={iframeClassNames}
          src={embedUrl}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; compute-pressure"
          allowFullScreen
          style={{
            borderRadius: `${borderRadius}px`,
          }}
        />
      );
    } else {
      return <video src={embedUrl} className={iframeClassNames}></video>;
    }
  }

  return (
    <>
      <div className={styles.videoWrapper}>{videoElement(embedUrl)}</div>
    </>
  );
}
